module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/stream-browserify/~/isarray/index.js
 ** module id = 785
 ** module chunks = 0
 **/